import React from 'react';
import PageShell from '@/components/PageShell';
import AboutSection from '@/components/sections/AboutSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import SectionDivider from '@/components/SectionDivider';
import PhotoStrip, { galleryImages as g } from '@/components/PhotoStrip';

const About = () => (
  <PageShell
    title="About Precision Vapour Blasting | Christchurch Workshop"
    description="Christchurch-based vapour blasting workshop in Islington. Restoring engine, marine and industrial parts across Canterbury, New Zealand."
    canonicalPath="/about"
    crumbs={[{ name: 'About', path: '/about' }]}
  >
    <h1 className="sr-only">About Our Christchurch Vapour Blasting Workshop</h1>
    <AboutSection />
    <SectionDivider />
    <section className="bg-background">
      <div className="container-wide mx-auto px-4 md:px-8">
        <PhotoStrip
          heading="Recent work from the workshop"
          blurb="A snapshot of parts restored in our Islington shop."
          images={[g.head, g.carb1, g.gearbox, g.hub]}
        />
      </div>
    </section>
    <SectionDivider />
    <TestimonialsSection />
  </PageShell>
);

export default About;

